<template>
  <section class="images-page" :class="type">
    <img v-for="(item, index) in IMAGES[type]" :key="index" :src="item" alt="">
  </section>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'

const IMAGES = {
  'henan': [
    'https://wecos.etczs.net/pages/newApply/assets/images/goods_banner_henan.png',
    'https://wecos.etczs.net/pages/newApply/assets/images/henan_introduce_text.png'
  ],
  'paySuccess1': [
    'https://wecos.etczs.net/H5/pay-success-1.gif'
  ],
  'paySuccess2': [
    'https://wecos.etczs.net/H5/pay-success-2.gif'
  ],
  'paySuccesstencent': [
    'https://wecos.etczs.net/H5/pay-success-qq.gif'
  ],
  'paySuccesstoutiao': [
    'https://wecos.etczs.net/H5/pay-success-qq.gif'
  ]
}
export default {
  name: 'imagesPage',
  mixins: [FunMixin],
  components: {},
  props: {
    type: String
  },
  data() {
    return {
      IMAGES
    }
  },
  computed: {},
  methods: {},
  created() {
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";
.images-page{
  font-size: 0;
  &.paySuccess{
    @extend %flex-center;
    background-color: #000000;
    img{
      max-height: 100vh;
    }
  }
  &.paySuccesstencent,.paySuccesstoutiao{
    @extend %flex-center;
    background-color: #000000;
    position: absolute;
    height: 100%;
    width: 100%;
    img{
      max-height: 100vh;
      height: 100%;
    }
  }
}
</style>
